import baseService from '../shared/baseService';

const vehicleDictionaryService = baseService('vehicle-dictionarys');

export default {
    ...vehicleDictionaryService
};
